export const PUSHS_GET_REQUEST = "PUSHS_GET_REQUESTED";
export const PUSHS_GET_SUCCESS = "PUSHS_GET_SUCCESS";
export const PUSHS_GET_ERROR = "PUSHS_GET_ERROR";
